// OrdersPage.js
import React from 'react';
import { Routes, Route } from 'react-router-dom'; // No need to import Router here
import OrdersListPage from './OrdersListPage';
import OrdersFormPage from './OrdersFormPage';

const OrdersPage = () => {
  return (
    <div>
      <Routes> {/* No Router here */}
        <Route path="/new" element={<OrdersFormPage />} />
        <Route path="/:id" element={<OrdersFormPage />} />
        <Route path="/" element={<OrdersListPage />} />
      </Routes>
    </div>
  );
};

export default OrdersPage;
